import { connect } from 'react-redux';

import { getFirstPreviousOrderId } from 'redux/modules/orders/selectors/get-orders';

import ShopFromRecentOrder from './ShopFromRecentOrder';

export default connect(state => ({
  previousOrderId: getFirstPreviousOrderId(state),
}))(ShopFromRecentOrder);
